import styled from "styled-components";

export const SearchContainer = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 80px;
  background: #F5F5F5;
  min-height: 100vh;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  background: white;
  border-bottom: 1px solid #E5E5E5;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  border: none;
  background: none;
  padding: 8px;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  display: flex;
  align-items: center;
`;

export const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

export const SearchSection = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SearchInputBox = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background-color: white;
  border: 1px solid #E5E5E5;
  border-radius: 25px;
  padding: 12px 20px;
  gap: 10px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  background: none;
  outline: none;
  font-size: 16px;
  color: #333;
  cursor: pointer;

  &::placeholder {
    color: #666;
  }
`;

export const SearchIcon = styled.div`
  font-size: 20px;
  color: #999;
  display: flex;
  align-items: center;
`;

export const ClearButton = styled.button`
  background: none;
  border: none;
  color: #999;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;

  &:hover {
    color: #666;
  }
`;


export const SearchContent = styled.div`
  padding: 0 20px 20px;
  text-align: left;
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin: 20px 0 15px;
  color: #1FBC70;
  text-align: left;
`;

export const RecentSearches = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SearchTag = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: white;
  border-radius: 20px;
  font-size: 14px;
  color: #333;
  cursor: pointer;

  &:hover {
    background-color: #F5F5F5;
  }
`;

export const TagText = styled.span`
  cursor: pointer;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  font-size: 16px;
  color: #999;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;

  &:hover {
    color: #333;
  }
`;

export const PopularList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PopularItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  font-size: 16px;
  color: #333;

  &:hover {
    color: #1FBC70;
  }
`;

export const ItemNumber = styled.span`
  color: #333;
  font-weight: 500;
`;

export const ItemText = styled.span`
  flex: 1;
`;

export const SearchResults = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ResultCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  gap: 12px;
  position: relative;
`;

export const ResultImage = styled.div`
  width: 140px;
  height: 140px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ResultInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ResultHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ResultTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: left;
`;

export const ResultArrow = styled.div`
  font-size: 20px;
  color: #999;
  cursor: pointer;
`;

export const ResultLocation = styled.div`
  font-size: 14px;
  color: #666;
  text-align: left;
`;

export const ResultTime = styled.div`
  font-size: 14px;
  color: #666;
  text-align: left;
`;

export const ReserveButton = styled.button`
  margin-top: auto;
  background-color: #1FBC70;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  align-self: flex-start;

  &:hover {
    background-color: #1AAA64;
  }
`;

export const EmptyMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
`;
